/**
 * APIL Url: ADAC.Internet.Core.Models.Schadenmeldung.SchadenKosten
 * Schadenskosten, Werte: Ok = 0; MehrAlsKostengrenzeEins = 1; MehrAlsKostengrenzeZwei = 2; 
 */
export enum SchadenKostenApi {
	Ok = 0,  // Ok
	MehrAlsKostengrenzeEins = 1,  // MehrAlsKostengrenzeEins
	MehrAlsKostengrenzeZwei = 2  // MehrAlsKostengrenzeZwei
};